export const Reason = {
  apply: 'apply',
  cancel: 'cancel',
} as const;
export type ReasonKeys = (typeof Reason)[keyof typeof Reason];
